import React from 'react'

import { useClass } from '@/hooks/useClass'

const variantStyles = {
  h1: 'text-2xl font-bold mb-16',
  h2: 'text-md font-bold',
  h3: 'text-sm',
  p: 'text-sm',
}

type TextAsProps = {
  as: keyof typeof variantStyles
}

type TextProps = React.ComponentProps<TextAsProps['as']> & TextAsProps

export const Text = ({
  as: CustomText,
  className,
  children,
  ...props
}: TextProps) => {
  const textClass = useClass(variantStyles[CustomText], className)

  return (
    <CustomText className={textClass} {...props}>
      {children}
    </CustomText>
  )
}
